import Axios from "axios";
import Config from "../../config";
import { generateQueryStringURL } from "../helpers/API";

const HermesAPI = {
    // eslint-disable-next-line no-unused-vars,max-lines-per-function
    install(Vue) {
        const axios = Axios.create({
            baseURL: Config.hermesAPI.baseURL,
            timeout: 0,
            headers: {
                "Content-Type": "application/json",
            },
            auth: {
                username: Config.hermesAPI.basicAuth.username,
                password: Config.hermesAPI.basicAuth.password,
            },
        });

        Vue.prototype.$hermesAPI = {};

        Vue.prototype.$hermesAPI.getConfig = () => axios.get("/");

        Vue.prototype.$hermesAPI.getBooksellers = () => axios.get("/users");

        Vue.prototype.$hermesAPI.postBookseller = bookseller => axios.post("/users", bookseller);

        Vue.prototype.$hermesAPI.patchBookseller = bookseller => axios.patch(`/users/${bookseller._id}`, bookseller);

        Vue.prototype.$hermesAPI.getWithdrawalPoints = () => axios.get("/withdrawal-points");

        Vue.prototype.$hermesAPI.postWithdrawalPoint = withdrawalPoint => axios.post("/withdrawal-points", withdrawalPoint);

        Vue.prototype.$hermesAPI.patchWithdrawalPoint = withdrawalPoint => axios.patch(`/withdrawal-points/${withdrawalPoint._id}`, withdrawalPoint);

        Vue.prototype.$hermesAPI.getOrders = () => axios.get("/orders");

        Vue.prototype.$hermesAPI.getOrder = (id, queryStrings) => axios({ method: "get", url: generateQueryStringURL(`/orders/${id}`, queryStrings), data: {}, responseType: "arraybuffer" });
    },
};

export default HermesAPI;